<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="优惠券名称：" prop="couponName">
            <el-input style="width: 424px;" v-model="ruleForm.couponName" placeholder="请输入优惠券名称"></el-input>
          </el-form-item>
          <el-form-item label="优惠券类型：" prop="couponType">
            <el-select style="width: 424px;" v-model="ruleForm.couponType" placeholder="请选择优惠券类型">
              <el-option label="商城通用券" :value="1"></el-option>
              <el-option label="商城满减券" :value="2"></el-option>
              <el-option label="商城品类通用券（商品分类）" :value="3"></el-option>
              <el-option label="商城品类满减券" :value="4"></el-option>
              <el-option label="商城商品券" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.couponType == 3 || ruleForm.couponType == 4" label="品类：" prop="businessIdList">
            <el-select style="width: 424px;" v-model="ruleForm.businessIdList" multiple placeholder="请选择">
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.couponType == 5" label="商品：" prop="businessIdList">
            <el-button @click="goodsOpenBtn">添加商品</el-button>
            <el-table
              v-if="multipleSelectionSure.length > 0"
              style="margin-top: 16px;width: 476px;"
              border
              :data="multipleSelectionSure">
              <el-table-column
                align="center"
                prop="businessName"
                label="商品名称">
              </el-table-column>
              <el-table-column
                align="center"
                prop="businessThumb"
                label="图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 40px;"
                    :src="scope.row.businessThumb"
                    :preview-src-list="[scope.row.businessThumb]"
                    fit="contain"></el-image>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作">
                <template slot-scope="scope">
                  <span @click="goodsDelBtn(scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="优惠券金额：" prop="couponMoney">
            <el-input style="width: 424px;" v-model="ruleForm.couponMoney" placeholder="请输入优惠券金额"></el-input>
          </el-form-item>
          <el-form-item label="有效期（小时）：" prop="validHours">
            <el-input style="width: 424px;" v-model="ruleForm.validHours" placeholder="请输入优惠券有效期（小时）"></el-input>
            <div class="mt-warm-txt">发放至用户账户开始计算有效期</div>
          </el-form-item>
          <el-form-item label="库存：" prop="stockNum">
            <el-input style="width: 424px;" v-model="ruleForm.stockNum" placeholder="请输入优惠券库存"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.couponType == 2 || ruleForm.couponType == 4" label="最低消费额：" prop="minimumSpendMoney">
            <el-input style="width: 424px;" v-model="ruleForm.minimumSpendMoney" placeholder="请输入最低消费额"></el-input>
          </el-form-item>
          <el-form-item label="使用规则：" prop="useRule">
            <el-input style="width: 424px;" rows="5" type="textarea" v-model="ruleForm.useRule" placeholder="请输入使用规则"></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 选择商品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsShow"
      width="960px">
      <el-form :model="searchForm" inline ref="searchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="商品分类：" prop="categoryId">
          <el-cascader
            placeholder="请选择"
            :options="cateOptions"
            @change="searchCateChangeBtn"
            filterable></el-cascader>
        </el-form-item>
        <el-form-item label="商品名称：" prop="name">
          <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        border
        :data="infoList"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="businessId"
          label="ID">
        </el-table-column>
        <el-table-column
          align="center"
          prop="businessThumb"
          label="商品图">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;"
              :src="scope.row.businessThumb"
              :preview-src-list="[scope.row.businessThumb]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="businessName"
          label="商品名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="businessCategoryName"
          label="商品分类">
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="goodsSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveCoupon, fetchCouponDetailById, updateCoupon, queryAllEnableGoodsCategoryList, queryAllEnableGoodsList } from '@/api/coupon'
import { searchCateInfo } from '@/api/goods'
export default {
  name: 'CouponAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      /* 搜索上的分类数据 */
      cateOptions:[],
      searchForm: {
        name:'',
        categoryId:''
      },
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      cateList:[],
      ruleForm: {
        couponName: '',
        couponType: '',
        businessIdList:[],
        couponMoney: '',
        validHours: '',
        stockNum: '',
        minimumSpendMoney: '',
        useRule: '',
        sort: '',
        status: false
      },
      rules: {
        couponName: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' }
        ],
        couponType: [
          { required: true, message: '请选择优惠券类型', trigger: 'blur' }
        ],
        businessIdList: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        couponMoney: [
          { required: true, message: '请输入优惠券金额', trigger: 'blur' }
        ],
        validHours: [
          { required: true, message: '请输入优惠券有效期（小时）', trigger: 'blur' }
        ],
        stockNum: [
          { required: true, message: '请输入优惠券库存', trigger: 'blur' }
        ],
        minimumSpendMoney: [
          { required: true, message: '请输入最低消费额', trigger: 'blur' }
        ]
      },
      // 选择商品弹窗
      goodsShow:false,
      multipleSelection: [],
      multipleSelectionSure: []
    }
  },
  created() {
    this.cateListFun();
    this.searchCateFun();
    this.getInfoList();
  },
  mounted () {
    if (this.$route.query.dataId != '') {
      let that = this
      fetchCouponDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.couponName = data.couponName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.sort = data.sort
          that.ruleForm.couponType = data.couponType
          that.ruleForm.couponMoney = data.couponMoney
          that.ruleForm.validHours = data.validHours
          that.ruleForm.stockNum = data.stockNum
          that.ruleForm.minimumSpendMoney = data.minimumSpendMoney
          that.ruleForm.useRule = data.useRule
          that.ruleForm.businessIdList = data.businessIdList == null ? [] : data.businessIdList
          that.multipleSelectionSure = data.couponBusinessPageVoList == null ? [] : data.couponBusinessPageVoList
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    getRowKeys(row) {
      return row.businessId
      // 需要return的是一个唯一的标识值
    },
    // 品类数据
    cateListFun(){
      var that = this;
      queryAllEnableGoodsCategoryList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.cateList = data
        }
      })
    },
    // 选择商品弹窗-打开弹窗
    goodsOpenBtn(){
      this.goodsShow = true;
    },
    // 选择商品弹窗-删除已选择的商品
    goodsDelBtn(index){
      // this.multipleSelection.splice(index,1);
      this.multipleSelectionSure.splice(index,1);
    },
    /* 选择商品弹窗-搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    /* 选择商品弹窗-搜索上的分类数据 */
    searchCateFun(){
      var that = this;
      searchCateInfo().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          data.unshift({
            value: '0',
            label: '全部'
          })
          that.cateOptions = data;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    /* 选择商品弹窗-搜索上的分类数据-监听改变操作 */
    searchCateChangeBtn(value){
      this.searchForm.categoryId = value[1];
    },
    // 选择商品弹窗-选择商品操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择商品弹窗-确认选择
    goodsSureBtn(){
      var multipleSelection = this.multipleSelection;
      if(multipleSelection.length == 0){
        this.$message.error('请选择商品');
        return false;
      }
      this.multipleSelectionSure = multipleSelection;
      this.goodsShow = false;
    },
    // 选择商品弹窗-获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let categoryId = that.searchForm.categoryId
      let page = that.currentPage
      queryAllEnableGoodsList({ goodsName: searchName, categoryId: categoryId, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let couponName = that.ruleForm.couponName
      let couponType = that.ruleForm.couponType
      let couponMoney = that.ruleForm.couponMoney
      var validHours = that.ruleForm.validHours
      var stockNum = that.ruleForm.stockNum
      var minimumSpendMoney = that.ruleForm.minimumSpendMoney
      var useRule = that.ruleForm.useRule
      var businessIdList = that.ruleForm.businessIdList
      let status = that.ruleForm.status ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      var multipleSelectionSure = that.multipleSelectionSure
      if(couponType == 5){
        var goodsArr = [];
        multipleSelectionSure.forEach(function(item){
          goodsArr.push(item.businessId)
        });
        businessIdList = goodsArr;
      }
      if (couponName === '') {
        this.$message.error('请输入优惠券名称')
        return false
      }
      if (couponType === '') {
        this.$message.error('请选择优惠券类型')
        return false
      }
      if (couponMoney === '') {
        this.$message.error('请输入优惠券金额')
        return false
      }
      if (validHours === '') {
        this.$message.error('请输入优惠券有效期')
        return false
      }
      if (stockNum === '') {
        this.$message.error('请输入优惠券库存')
        return false
      }
      if (minimumSpendMoney === '') {
        if(couponType == 2 || couponType == 4){
          this.$message.error('请输入最低消费额')
          return false
        }
      }
      if (businessIdList.length === 0) {
        if(couponType == 3){
          this.$message.error('请选择品类')
          return false
        }
        if(couponType == 5){
          this.$message.error('请选择商品')
          return false
        }
      }
      let passData = {
        couponName: couponName, couponType: couponType, couponMoney: couponMoney, validHours: validHours, stockNum: stockNum, minimumSpendMoney: minimumSpendMoney, useRule: useRule, businessIdList: businessIdList, status: status, sort: sort
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateCoupon(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveCoupon(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/coupon/Add.vue